import { apiClient } from "./client";
import type { Paginated, PageQuery } from "@/types/common";
import type { Group, GroupCreateInput, ScheduleGrid } from "@/types/group";
import type { Student } from "@/types/student";
import { DAYSET_DAYS, type Dayset } from "@/types/enums";

export interface GroupsQuery extends PageQuery {
  branchId?: string;
  status?: string;
  subjectId?: string;
  teacherId?: string;
}

export async function fetchGroups(query: GroupsQuery): Promise<Paginated<Group>> {
  const { data } = await apiClient.get<Paginated<Group>>("/groups", { params: query });
  return data;
}

export async function fetchGroup(id: string): Promise<Group> {
  const { data } = await apiClient.get<Group>(`/groups/${id}`);
  return data;
}

export async function createGroup(payload: GroupCreateInput): Promise<Group> {
  const { data } = await apiClient.post<Group>("/groups", payload);
  return data;
}

export async function updateGroup(id: string, payload: Partial<GroupCreateInput>): Promise<Group> {
  const { data } = await apiClient.patch<Group>(`/groups/${id}`, payload);
  return data;
}

export async function fetchGroupStudents(groupId: string): Promise<Student[]> {
  const { data } = await apiClient.get<Student[]>(`/groups/${groupId}/students`);
  return data;
}

export async function fetchScheduleGrid(params: { branchId: string; dayset: Dayset }): Promise<ScheduleGrid> {
  const days = DAYSET_DAYS[params.dayset].join(",");
  const { data } = await apiClient.get<ScheduleGrid>("/groups/schedule-grid", {
    params: { branchId: params.branchId, days, dayset: params.dayset },
  });
  return data;
}

export async function fetchActiveGroupsBySubject(subjectId: string, branchId: string): Promise<Group[]> {
  const { data } = await apiClient.get<Group[]>("/groups", {
    params: { subjectId, branchId, status: "ACTIVE", limit: 100 },
  });
  return (data as unknown as Paginated<Group>).items ?? (data as unknown as Group[]);
}
